<template>
  <a-card :bordered="false">
    <a-form-model
      :model="ruleForm"
      ref="ruleForm"
      :rules="tabRule"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <!--      <a-row>-->
      <!--        <a-col :span="4">-->
      <!--          <h3 class="title">跟团游:</h3>-->
      <!--        </a-col>-->
      <!--      </a-row>-->
      <a-form-model-item label="API_URL" prop="apiUrl">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.apiUrl"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="acctId" prop="acctId">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.acctId"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="apikey" prop="apiKey">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.apiKey"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="publictest" prop="publicTest">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.publicTest"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="secretkey" prop="secretKey">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.secretKey"
          :maxLength="50"
        />
      </a-form-model-item>
      <!--      <a-row>-->
      <!--        <a-col :span="4">-->
      <!--          <h3 class="title">公共服务:</h3>-->
      <!--        </a-col>-->
      <!--      </a-row>-->
      <!--      <a-form-model-item label="API_URL" prop="publicApiUrl">-->
      <!--        <a-input-->
      <!--          placeholder="请输入"-->
      <!--          v-model="ruleForm.publicApiUrl"-->
      <!--          :maxLength="50"-->
      <!--        />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="acctId" prop="publicAcctId">-->
      <!--        <a-input-->
      <!--          placeholder="请输入"-->
      <!--          v-model="ruleForm.publicAcctId"-->
      <!--          :maxLength="50"-->
      <!--        />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="apikey" prop="publicApiKey">-->
      <!--        <a-input-->
      <!--          placeholder="请输入"-->
      <!--          v-model="ruleForm.publicApiKey"-->
      <!--          :maxLength="50"-->
      <!--        />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="secretkey" prop="publicSecretKey">-->
      <!--        <a-input-->
      <!--          placeholder="请输入"-->
      <!--          v-model="ruleForm.publicSecretKey"-->
      <!--          :maxLength="50"-->
      <!--        />-->
      <!--      </a-form-model-item>-->
      <!--      <a-row>-->
      <!--        <a-col :span="4">-->
      <!--          <h3 class="title">业务人员:</h3>-->
      <!--        </a-col>-->
      <!--      </a-row>-->
      <a-form-model-item label="分销商业务联系人邮箱" prop="distributeLinkMail">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.distributeLinkMail"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="分销商业务联系人电话" prop="distributeLinkPhone">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.distributeLinkPhone"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item label="分销商业务联系人姓名" prop="distributeLinkName">
        <a-input
          placeholder="请输入"
          v-model="ruleForm.distributeLinkName"
          :maxLength="50"
        />
      </a-form-model-item>
      <a-form-model-item style="text-align: center" :wrapper-col="{ span: 9, offset: 3 }">
        <a-button
          htmlType="submit"
          type="primary"
          @click="submitEvent"
          :loading="submitLoading"
        >保存
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import TuNiuMixins from '@/views/service/serviceProvider/tuNiuConnection/mixins/TuNiuMixins'
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'TuNiuApiConfigure',
  mixins: [searchForm, TuNiuMixins],
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 10 },
      ruleForm: {},
      tabRule: {
        apiUrl: [
          { required: true, message: '请输入API_URL', trigger: ['blur', 'change'] }
        ],
        acctId: [
          { required: true, message: '请输入acctId', trigger: ['blur', 'change'] }
        ],
        apiKey: [
          { required: true, message: '请输入apikey', trigger: ['blur', 'change'] }
        ],
        publicTest: [
          { required: true, message: '请输入publictest', trigger: ['blur', 'change'] }
        ],
        secretKey: [
          { required: true, message: '请输入secretkey', trigger: ['blur', 'change'] }
        ],
        publicApiUrl: [
          { required: true, message: '请输入API_URL', trigger: ['blur', 'change'] }
        ],
        publicAcctId: [
          { required: true, message: '请输入acctId', trigger: ['blur', 'change'] }
        ],
        publicApiKey: [
          { required: true, message: '请输入apikey', trigger: ['blur', 'change'] }
        ],
        publicSecretKey: [
          { required: true, message: '请输入secretkey', trigger: ['blur', 'change'] }
        ],
        distributeLinkMail: [
          { required: true, message: '请输入分销商业务联系人邮箱', trigger: ['blur', 'change'] }
        ],
        distributeLinkPhone: [
          { required: true, message: '请输入分销商业务联系人电话', trigger: ['blur', 'change'] }
        ],
        distributeLinkName: [
          { required: true, message: '请输入分销商业务联系人姓名', trigger: ['blur', 'change'] }
        ]
      },
      submitLoading: false
    }
  },
  mounted() {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo() {
      this.getHttpServices().getServerApiService().post('/v2/tuniu/config/query', {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      }).then(res => {
        if (res) this.ruleForm = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    submitEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        let params = {
          ...this.ruleForm,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          createTime: undefined,
          updateTime: undefined
        }
        this.getHttpServices().getServerApiService().post('/v2/tuniu/config/save', params).then(res => {
          this.$message.success('API配置成功')
          this.getDetailInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-weight: bold;
  padding-right: 20px;
  text-align: right;
}
</style>
